export default "__VITE_ASSET__CU4dZs7T__"